export default "__VITE_ASSET__CeI1a4Q3__"